import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-ibm-plex-sans\",\"display\":\"swap\"}],\"variableName\":\"ibmPlexSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"],\"variable\":\"--font-ibm-plex-mono\",\"display\":\"swap\"}],\"variableName\":\"ibmPlexMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AuthGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EduTrackProvider"] */ "/app/src/contexts/EduTrackContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
